import { motion } from "framer-motion";
import { Check } from "lucide-react";

export const FormSuccess = ({ title, text, onReset, testId }) => (
  <motion.div initial={{ opacity: 0, scale: 0.96 }} animate={{ opacity: 1, scale: 1 }} data-testid={testId} className="rounded-[28px] border-2 border-dano-ink bg-dano-gold p-8 sm:p-12">
    <span className="grid h-14 w-14 place-items-center rounded-full bg-dano-ink text-dano-cream"><Check className="h-6 w-6" /></span>
    <h3 className="mt-6 font-wide text-3xl uppercase">{title}</h3>
    <p className="mt-3 max-w-md">{text}</p>
    <button onClick={onReset} data-testid={`${testId}-reset`} className="mt-6 font-cond uppercase tracking-widest underline underline-offset-4">Send another</button>
  </motion.div>
);
